import axios from 'axios'
import qs from 'qs'
import { vm } from '@/main'
import { OK_STATUS, ILLEGAL_STATUS, PAYMENT_COMPLETED, DUPLICATED_BINDING_CARD } from '@/const/status'
import { get } from 'lodash-es'
import { apiURL } from '@/const/base-url'
import { getLocale } from '@/utils/localstorage-provider'

// create an axios instance
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

const request = axios.create({
  baseURL: apiURL
})

const silentRequest = axios.create({
  baseURL: apiURL
})

request.interceptors.request.use(
  function (config) {
    vm.$Spin.show()
    config.transformRequest = [
      function (data) {
        return qs.stringify(data)
      }
    ]
    config.params = {
      hlang: getLocale()
    }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

request.interceptors.response.use(function (response) {
  // Do something with response data
  vm.$Spin.hide()
  const { status } = response
  if (status === OK_STATUS) {
    const { ret } = response.data
    const goTo = get(vm, '$children[0].handleGoTo', () => {
    })
    switch (ret) {
      case OK_STATUS:
      case 0:
        return response.data.data
      case ILLEGAL_STATUS:
        goTo({ component: 'Result', type: 'failure' })
        return Promise.reject(response)
      case PAYMENT_COMPLETED:
        goTo({ component: 'Result', type: 'unknown' })
        return Promise.reject(response)
      case DUPLICATED_BINDING_CARD:
        goTo({ component: 'Result', type: 'failure', duplicated: true })
        return Promise.reject(response)
      default:
        vm.$Message.warning(response.data.msg || vm.$t('errors.unknownServerError'))
        goTo({ component: 'Result', type: 'failure' })
        return Promise.reject(response)
    }
  } else {
    vm.$Message.warning(response.data.msg || vm.$t('errors.unknownServerError'))
  }
},
(error) => {
  vm.$Spin.hide()
  return Promise.reject(error)
})

silentRequest.interceptors.request.use(
  function (config) {
    config.transformRequest = [
      function (data) {
        return qs.stringify(data)
      }
    ]
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

silentRequest.interceptors.response.use(function (response) {
  // Do something with response data
  vm.$Spin.hide()
  const { status } = response
  if (status === OK_STATUS) {
    const { ret, data, hlang } = response.data
    const goTo = get(vm, '$children[0].handleGoTo', () => {})
    switch (ret) {
      case OK_STATUS:
      case 0:
        return { data, hlang }
      case ILLEGAL_STATUS:
        goTo({ component: 'Result', type: 'failure' })
        return Promise.reject(response)
      case DUPLICATED_BINDING_CARD:
        goTo({ component: 'Result', type: 'failure', duplicated: true })
        return Promise.reject(response)
      default:
        return Promise.reject(response)
    }
  }
},
(error) => {
  vm.$Spin.hide()
  return Promise.reject(error)
})

export function getCashierDetail (data) {
  return request.post('/pay/render', data)
}

export function applyPay (data) {
  return request.post('/pay/applyPay', data)
}

export function queryPay (data) {
  return silentRequest.post('/pay/queryPay', data)
}
export function getRegionInfo () {
  return request.get('https://region-configuration.lalamove.com/index.php?env=prd')
}

export function getAdyenConfig (data) {
  return request.post('/payConfig/adyenPaymentMethods', data)
}
export function adyenAction (data) {
  return request.post('/payConfig/adyenAction', data)
}
export function deleteAdyenCard (data) {
  return request.post('/payConfig/adyenDisable', data)
}

export function getTappayConfig (data) {
  return request.post('/payConfig/channelConfig', data)
}
export function deleteTappayCard (data) {
  return request.post('/payConfig/tapDisable', data)
}

export function getSKDConfig (data) {
  return request.post('/payConfig/assetsConsulting', data)
}
export function applyBinding (data) {
  return request.post('/card/bingDing', data)
}
export function queryBinding (data) {
  return silentRequest.post('/card/queryBingDing', data)
}
